import moment from 'moment';

// TO USE IT:
// get all fucntion
// import * as timeUtils from '../utils/timeUtils';

// get one function
// import { formatLocalTime } from '../utils/TimeUtils.js';

let currentTimeZone = 'America/New_York'
let defaultFormat = 'YYYY-MM-DD HH:mm:ss'
let gqlDefaultFormat = 'YYYY-MM-DDTHH:mm:ss'

export function formatLocalTime(utcTime, format = defaultFormat, timeZone = currentTimeZone) {
    if (!utcTime) return '';
    return moment(utcTime).tz(timeZone).format(format);
}

export function formatTimeWithLocalTimeZone(localTimeZoneTime, format = defaultFormat, timeZone = currentTimeZone) {
    if (!localTimeZoneTime) return '';
    return moment.tz(localTimeZoneTime, timeZone).format(gqlDefaultFormat);
}

export function getCurrentTimeForZone(timeZone = currentTimeZone, format = defaultFormat) {
    return moment().tz(timeZone).format(format);
}

export function getCurrentTimeForZoneGQL(timeZone = currentTimeZone, format = gqlDefaultFormat) {
    return moment().tz(timeZone).format(format);
}

export function getCurrentDateForZone(timeZone = currentTimeZone) {
    return moment().tz(timeZone).format('YYYY-MM-DD');
}

export function getTomorrowDateForZone(timeZone = currentTimeZone) {
    return moment().tz(timeZone).add(1, 'days').format('YYYY-MM-DD');
}

export function getDateForZone(time, timeZone = currentTimeZone) {
    return moment(time).tz(timeZone).format('YYYY-MM-DD');
}

export function getInitialDateRangeForCurrentDate(timeZone = currentTimeZone) {
    // use UTC timezone since later it will be converted to js Date object for flatpicker
    // and then moment will get the output and transfer it back to America/New_York Time
    const startOfDay = moment().tz('Etc/UTC').startOf('day').toDate();
    const endOfDay = moment().tz('Etc/UTC').endOf('day').toDate();
    return [startOfDay, endOfDay];
}

export function getInitialDateRangeForTodayAndTommorrow(timeZone = currentTimeZone) {
    const startOfDay = moment().tz('Etc/UTC').startOf('day').toDate();
    const endOfDay = moment().tz('Etc/UTC').add(1, "day").endOf('day').toDate();
    return [startOfDay, endOfDay];
}

export function getInitialDateRangeForCurrentWeek(timeZone = currentTimeZone) {
    const startOfDay = moment().tz('Etc/UTC').startOf('day').toDate();
    const endOfDay = moment().tz('Etc/UTC').add(-7, "day").endOf('day').toDate();
    return [startOfDay, endOfDay];
}